import React from 'react';
import { Button, Tooltip, Tag, Table, Empty } from 'antd';
import global from '../../../common/utility/global';
import auth from '../../../common/utility/auth';
import CustomTable from '../../../components/CustomTable';

export default function ResultList(props) {
    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    // width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">

                            <Tooltip placement="top" title="Ver Documentos cancelados" >
                                <Button
                                    disabled={row.idCuentasEstado == 3 || row.idCuentasEstado == 4}
                                    type="primary"
                                    icon="eye"
                                    size={"small"}
                                    // disabled={row.idComprobanteEstado !== REGISTRADO ? false : true}
                                    onClick={() => props.onViewPlanilla(row)}
                                />
                            </Tooltip>
                            <Tooltip placement="top" title="Eliminar Pago">
                                <Button
                                    disabled={row.idEstado == 3 ? false : true}
                                    type="danger"
                                    icon="close"
                                    size={"small"}
                                    onClick={() => props.onDelete(row)}
                                />
                            </Tooltip>
                            {(auth.user().id == row.idResponsable ?

                                <Tooltip placement="top" title="Realizar Abono">
                                    <Button
                                        type="primary"
                                        icon="plus"
                                        size={"small"}
                                        disabled={(row.idEstado == 5 || row.idEstado == 4) ? true : false}
                                        loading={props.loadingPago}
                                        onClick={() => props.onPago(row)}
                                    />
                                </Tooltip>
                                :
                                <Tooltip placement="top" title="Realizar Abono">
                                    <Button
                                        type="primary"
                                        icon="plus"
                                        size={"small"}
                                        disabled={(row.idEstado == 4) ? true : false}
                                        onClick={() => props.onPago(row)}
                                    />
                                </Tooltip>
                            )}

                        </div>
                    )
                },

                {
                    title: 'Fecha Apertura',
                    dataIndex: 'fechaApertura',
                    key: 'fechaApertura',
                    sorter: true,
                    align: 'center',
                },
                {
                    title: 'Fecha Cierre',
                    dataIndex: 'fechaCierre',
                    key: 'fechaCierre',
                    sorter: true
                },
                {
                    title: 'Nro Planilla',
                    dataIndex: 'nroPlanilla',
                    key: 'nroPlanilla',
                    sorter: true
                },
                {
                    title: 'Establecimiento',
                    dataIndex: 'establecimiento',
                    key: 'establecimiento',
                    sorter: true,
                    align: 'center',
                },
                {
                    title: 'Caja',
                    dataIndex: 'caja',
                    key: 'caja',
                    sorter: true
                },
                {
                    title: 'Monto',
                    className: 'parent-group parent-group-2',
                    children: [
                        {
                            title: 'Soles',
                            dataIndex: 'totalSoles',
                            key: 'totalSoles',
                            className: 'parent-group parent-group-2',

                            align: 'right',
                            render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            )
                        },
                        {
                            title: 'Dólares',
                            dataIndex: 'totalDolares',
                            key: 'totalDolares',
                            className: 'parent-group parent-group-2',

                            align: 'right',
                            render: (data) => (
                                <span>{data.toFixed(2)}</span>
                            )
                        }
                    ]
                },
                {
                    title: 'Tipo Cambio',
                    dataIndex: 'tipoCambio',
                    key: 'tipoCambio',
                    sorter: true,
                    align: 'center',
                    render: (value) => (
                        <span>{global.decimalFormat(value.toFixed(3))}</span>
                    )
                },
                {
                    title: 'Responsable Caja',
                    dataIndex: 'responsable',
                    key: 'responsable',
                    sorter: true
                },
                {
                    title: 'Responsable Arqueo',
                    dataIndex: 'responsableArqueo',
                    key: 'responsableArqueo',
                    sorter: true
                },

                {
                    title: 'Estado',
                    dataIndex: 'idEstado',
                    key: 'idEstado',
                    render: (value, row) => {
                        return (<div className="custom-options" >
                            {(() => {
                                switch (value) {
                                    case 2: //registado
                                        return <Tag color={"red"}>{row.estado}</Tag>;
                                    case 1://ANULADA
                                        return <Tag color={"green"}>{row.estado}</Tag>;
                                    case 3://ANULADA
                                        return <Tag color={"green"}>{row.estado}</Tag>;
                                    case 4://ANULADA
                                        return <Tag color={"red"}>{row.estado}</Tag>;
                                    case 5://ANULADA
                                        return <Tag color={"blue"}>{row.estado}</Tag>;
                                    default:
                                        return null;
                                }
                            })()}

                        </div>)
                    }
                }

            ]}
        />
    );
}